export default {
  title: 'المستخدمون',
  subtitle: 'قائمة المستخدمين',
  create: 'إضافة مستخدم'
}
